export default "__VITE_ASSET__CzXmzGB1__"